<template>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-9 col-md-10">
            <h5 class="card-title"><span class="aht">{{ $t('general.aht') }}</span> {{ $t('general.ahtRewardPool') }}</h5>
          </div>
        </div>
        <hr class="mt-0 mb-2">
        <div class="row pt-2 pb-3">
          <div class="col-4 col-md-4 text-center">
            <img class="safe" src="img/icons/safe.png" alt="safe">
          </div>
          <div ref="rewardpool" class="col-8 col-md-7 reward-pool text-right" v-show="!loading">
            {{fixedRewardPool}}
          </div>
          <div class="col-8 col-md-8 text-center" v-show="loading">
            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
          </div>
        </div>
        <div class="row">
          <div class="col-9 col-md-11 amount text-right pr-0">
            {{ rewardPool }} <span class="type-amount">{{ $t('general.aht') }}</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  computed: {
    fixedRewardPool () {
      let pool = 0

      if (this.$store.getters.getSurveyRewardPool % 1 !== 0) {
        pool = this.$store.getters.getSurveyRewardPool.toFixed(2)
      } else {
        pool = this.$store.getters.getSurveyRewardPool
      }

      return pool
    },
    rewardPool () {
      return this.$store.getters.getSurveyRewardPool
    },
    surveyName () {
      return this.$store.getters.getSurveyName
    }
  },
  data () {
    return {
      loading: true
    }
  },
  methods: {
    getFontSize (pool) {
      if (pool % 1 !== 0) {
        pool = this.$store.getters.getSurveyRewardPool.toFixed(2)
      }
      const baseLength = 6
      const fontSize = 2.7
      const rewardPoolDiv = this.$refs.rewardpool
      const textLength = pool.toString().length

      if (baseLength < textLength) {
        const newSize = fontSize * (baseLength / textLength)
        rewardPoolDiv.style.fontSize = `${newSize}rem`
      } else {
        rewardPoolDiv.style.fontSize = `${fontSize}rem`
      }
    }
  },
  async mounted () {
    const self = this

    setInterval(() => {
      self.$store.dispatch('getSurveyRewardPool')
    }, 60000)
  },
  watch: {
    rewardPool (pool) {
      this.getFontSize(pool)
      this.loading = false
    },
    async surveyName () {
      await this.$store.dispatch('getSurveyRewardPool')
    }
  }
}
</script>

<style scoped>
hr {
  margin-top: .8rem;
  margin-bottom: 0rem;
}

.aht {
  color: #66c9d8;
}

.card {
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  border-radius: 20px;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
  height: 220px;
}

.card-title {
  font: normal normal 600 17px Poppins;
  letter-spacing: 0px;
}

.safe {
  width: 96px;
  height: 96px;
  position: fixed;
  left: -1.2rem;
}

.reward-pool {
  padding-left: 0px;
  background: #212627 0% 0% no-repeat padding-box;
  border-radius: 12px;
  opacity: 1;
  padding-top: .5rem;
  padding-bottom: .5rem;
  font: normal normal 600 56px Poppins;
}

.amount {
  font-size: 10pt;
  color: #fff;
}

.type-amount {
  font-size: .8rem;
  color: #1fb5cc;
}
</style>
